import makeStyles from '@mui/styles/makeStyles';

export default makeStyles({
    root: {
        position: 'relative',
    },
    progress: {
        position: 'absolute',
    },
    progressCircleDeterminate: {
    }
})